import Button from "@components/Button";
import Link from "@components/Link";
import Image from "@components/Image";
import cx from "classnames";
import styles from "./ExploreArts.module.scss";
import { usePageContext } from "@providers/PageProvider";
import helper from "@utils/helper";
import getter from "@services/StrapiService/getter";
import _ from "lodash";

export default function ExploreArts() {
  const { pageData } = usePageContext();
  const hasData = !_.isEmpty(getter.exploreArts(pageData));
  const exploreArts = helper.formatExploreArts(pageData);
  const readMoreButton = _.get(exploreArts, "readMoreButton");
  if (!hasData) return null;
  return (
    <div data-scroll-section className={cx(styles.section)}>
      <Image
        wrapperProps={{ className: cx(styles.image) }}
        src={_.get(exploreArts, "image.src")}
        alt={_.get(exploreArts, "image.alt")}
        layout="fill"
        objectFit="cover"
      />
      <div className={cx(styles.content)}>
        <div className={cx(styles.des)}>
          {_.get(exploreArts, "description")}
        </div>
        <Link href={_.get(readMoreButton, "href")}>
          <Button
            type="icon"
            suffix="shape-arrow"
            className={cx(styles.exploreArts)}
            label={_.get(readMoreButton, "label")}
          />
        </Link>
      </div>
    </div>
  );
}
